import { Box, Stack, Typography } from '@mui/material';

import { default as OptimizeIcon } from './assets/optimize.svg?react';
import { default as LBTCIcon } from './assets/lbtc.svg?react';
import { default as UsdIcon } from './assets/usd.svg?react';
import { default as eBTCIcon } from './assets/ebtc.svg?react';
import { InfoBlock } from './InfoBlock';

export function Assets(): JSX.Element {
  return (
    <Box mt={3}>
      <Typography variant="subtitle1" fontWeight={500}>
        How it Works
      </Typography>

      <Stack gap={2} sx={{ flexDirection: { xs: 'column', md: 'row' } }} mt={2}>
        <InfoBlock
          title="Deposit"
          description={<>Deposit your LBTC or eBTC</>}
          left={
            <Stack
              flexDirection="row"
              justifyContent="flex-start"
              width="100%"
              sx={{ position: 'relative', pr: 2 }}
            >
              <Box
                component={eBTCIcon}
                sx={{ height: { xs: 32, sm: 40 }, left: 0 }}
              />
              <Box
                component={LBTCIcon}
                sx={{
                  height: { xs: 32, sm: 40 },
                  position: 'absolute',
                  left: { xs: 22, sm: 27 },
                }}
              />
            </Stack>
          }
        />
        <InfoBlock
          title="Optimize & Rebalance"
          description={
            <>
              The vault executes conservative DeFi strategies with continuous
              optimization and active rebalancing.
            </>
          }
          left={
            <Stack flexDirection="row" justifyContent="flex-start" width="100%">
              <Box
                component={OptimizeIcon}
                sx={{ height: { xs: 32, sm: 48 } }}
              />
            </Stack>
          }
        />
        <InfoBlock
          title="Farm on Sonic"
          description={
            <>
              Enjoy automated DeFi yields and rewards from Sonic, Lombard,
              Babylon and Veda, with no need for manual oversight.
            </>
          }
          left={
            <Stack flexDirection="row" justifyContent="flex-start" width="100%">
              <Box component={UsdIcon} sx={{ height: { xs: 32, sm: 48 } }} />
            </Stack>
          }
        />
      </Stack>
    </Box>
  );
}
